export default __webpack_public_path__ + "static/media/ellie4-2.a64912af.png";